module.exports = __webpack_public_path__ + "img/184-sweden.44fd2006.svg";